"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _gsap = require("gsap");

var _lottieWeb = _interopRequireDefault(require("lottie-web"));

var _color = _interopRequireDefault(require("color"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _string = require("lodash/string");

var _default = _interopRequireDefault(require("../../config/default.json"));

var _utils = require("../../utils");

var _LottieAnimationAPI2 = _interopRequireDefault(require("../LottieAnimationAPI"));

var _trustpilotUtils = _interopRequireDefault(require("./trustpilotUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function onDOMLoaded() {
  this.DOMLoaded = true;
  this.animation.removeEventListener('DOMLoaded', this.BindOnDOMLoaded);
  isReady(this);
}

function onLoadedImages() {
  this.imagesLoaded = true;
  this.animation.removeEventListener('loaded_images', this.BindOnLoadedImages);
  isReady(this);
}

function isReady(_self) {
  if (_self.DOMLoaded && _self.imagesLoaded) {
    _self.ready = true;

    _self.animation.trigger('ready');

    if (typeof _self.afterReady === 'function') {
      _self.afterReady();
    }
  }
}

var LottieAnimationBase = /*#__PURE__*/function (_LottieAnimationAPI) {
  _inherits(LottieAnimationBase, _LottieAnimationAPI);

  var _super = _createSuper(LottieAnimationBase);

  function LottieAnimationBase(animationName, data, config) {
    var _this;

    _classCallCheck(this, LottieAnimationBase);

    _this = _super.call(this);
    _this.config = config;
    _this.inDuration = config.inDuration;
    _this.intermissionDuration = config.intermissionDuration;
    _this.outDuration = config.outDuration;
    _this.totalDuration = config.totalDuration;
    _this.inputsData = (0, _trustpilotUtils.default)(data.review, config.inputs);

    if (data.style) {
      _this.style = data.style;
    }

    return _this;
  }
  /**
   * _loadAnimation() load lottie animation (private function)
   * load the lottie animation update animation data with size and fonts before load
   * set animation position and size if animation include style object
   */


  _createClass(LottieAnimationBase, [{
    key: "_loadAnimation",
    value: function _loadAnimation(data, container) {
      this.container = container;
      var style = {};
      this.innerContainer = document.createElement('span');

      _gsap.TweenMax.set(this.innerContainer, style);

      this.container.appendChild(this.innerContainer);
      this.animation = _lottieWeb.default.loadAnimation({
        container: this.innerContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: data
      }); // wait for image to be load than trigger custom ready event

      this.BindOnLoadedImages = onLoadedImages.bind(this);
      this.animation.addEventListener('loaded_images', this.BindOnLoadedImages);
      this.BindOnDOMLoaded = onDOMLoaded.bind(this);
      this.animation.addEventListener('DOMLoaded', this.BindOnDOMLoaded);
    }
  }, {
    key: "_setInputs",
    value: function _setInputs(animation, data, inputs) {
      var _this2 = this;

      inputs.forEach(function (input) {
        var key = input.key;
        var pattern = new RegExp("{#".concat((0, _string.toUpper)(key), "#}"), 'g');
        var value = _this2.inputsData.hasOwnProperty(key) ? _this2.inputsData[key] : '';
        animation = animation.replace(pattern, value);
      });
      return animation;
    }
  }, {
    key: "_setPackshot",
    value: function _setPackshot(animation, _ref) {
      var logo = _ref.logo;
      var logoUrl = _default.default.transparentPixle;
      var defaultLogoObj = {
        type: 'placeholder',
        value: '',
        style: {
          backgroundColor: 'rgb(255, 255, 255)',
          width: 250,
          height: 250,
          top: 0,
          left: 0,
          shape: 'none',
          imageOriginWidth: 250,
          imageOriginHeight: 250,
          imageHeight: '100%',
          imageWidth: '100%'
        }
      };
      logo = (0, _deepmerge.default)(defaultLogoObj, logo || {});

      if (logo && logo.type === 'image') {
        logoUrl = (0, _utils.NormalizeBaseUrl)(logo.value); // logo size and position
        // eslint-disable-next-line max-len

        var logoCompPattern = new RegExp("\"nm\":\"".concat(logo.style.shape, "_mask_logo_precomp\",\"refId\":\"([^\"]*)\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":\\[212,212,0],\"ix\":2},\"a\":{\"a\":0,\"k\":\\[150,150,0],\"ix\":1},\"s\":{\"a\":0,\"k\":\\[100,100,100],\"ix\":6}}"));
        var logoPatternMatch = animation.match(logoCompPattern);
        var refId = logoPatternMatch && logoPatternMatch.length > 1 ? logoPatternMatch[1] : 'copm_111';
        var logoCompBaseSize = 250;
        var scale = logo.style.width / logoCompBaseSize;
        var calcScale = scale * 100; // eslint-disable-next-line max-len

        var logoPreCompDynamic = "\"nm\":\"".concat(logo.style.shape, "_mask_logo_precomp\",\"refId\":\"").concat(refId, "\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[").concat(logo.style.left - 25 * scale, ",").concat(logo.style.top - 25 * scale, ",0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[").concat(calcScale, ", ").concat(calcScale, ",100],\"ix\":6}}"); // const logosizePattern = new RegExp('\\[70, 70, 100]', 'g')
        // animation = animation.replace(logosizePattern, `[${calcScale}, ${calcScale},100]`)

        animation = animation.replace(logoCompPattern, logoPreCompDynamic); // image size

        var imageWidth;
        var imageHeight;
        var imageBaseSize = 250;

        if (logo.style.imageOriginWidth > logo.style.imageOriginHeight) {
          // based on the width
          imageWidth = imageBaseSize * (parseFloat(logo.style.imageWidth) / 100);
          imageHeight = imageWidth / logo.style.imageOriginWidth * logo.style.imageOriginHeight;
        } else {
          // based on the height
          imageHeight = imageBaseSize * (parseFloat(logo.style.imageHeight) / 100);
          imageWidth = imageHeight / logo.style.imageOriginHeight * logo.style.imageOriginWidth;
        }

        var imageSizePattern = new RegExp('"id":"image_0","w":250,"h":250', 'g');
        var imageAnchorPattern = new RegExp('"k":\\[125,125,0]', 'g');
        animation = animation.replace(imageSizePattern, "\"id\":\"image_0\",\"w\":".concat(imageWidth, ",\"h\":").concat(imageHeight)).replace(imageAnchorPattern, "\"k\":[".concat(imageWidth * 0.5, ",").concat(imageHeight * 0.5, ",0]")); // logo BG color

        var logoBgColorPattern = new RegExp('"k":\\[1,0,0,1]', 'g'); // "k":[1,0,0,1]

        animation = animation.replace(logoBgColorPattern, "\"k\":[".concat((0, _utils.colorConvertLottie)((0, _color.default)(logo.style.backgroundColor).rgb().array()).join(','), "]"));
      }

      var newAnimation = animation.replace(/images\//g, ' ').replace(/img_0.png/g, logoUrl);
      return newAnimation;
    }
  }, {
    key: "prepareAssets",
    value: function prepareAssets() {
      window.console.log('OUTRO - prepareAssets');
      var assetPromises = this.json.assets.filter(function (asset) {
        return asset.id.indexOf('image') !== -1;
      }).filter(function (asset) {
        return asset.p.substring(0, 5) !== 'data:';
      }).map(function (asset) {
        return (0, _utils.toDataURL)(asset.p).then(function (b64) {
          asset.p = b64;
        });
      });
      return Promise.all([(0, _utils.LoadFonts)()].concat(_toConsumableArray(assetPromises)));
    }
  }]);

  return LottieAnimationBase;
}(_LottieAnimationAPI2.default);

exports.default = LottieAnimationBase;